/**
 * Platform flags — adds a class to <html> so CSS can work around engine-specific quirks.
 *
 * `.is-ios` marks iOS / iPadOS (all browsers there are WebKit). Used to disable
 * backdrop-filter effects that misrender on mobile Safari — e.g. the cookie-banner
 * backdrop, whose fixed `::before` blur composites over the z-999 banner and "blocks" it.
 * iPadOS 13+ reports its UA as a Mac, so `maxTouchPoints` catches it.
 */
export function platformFlags() {
  const ua = navigator.userAgent || '';
  const isIOS =
    /iP(hone|od|ad)/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (isIOS) document.documentElement.classList.add('is-ios');
}
